export type Type = {
	searchTerm: string;
};

export function create(): Type {
	return {
		searchTerm: '',
	};
}

export function setSearchTerm(state: Type, input: string): Type {
	return { ...state, searchTerm: input };
}
